import React from 'react';
import { ServicesContext } from './ServicesProvider.esm.js';

const useServicesContext = ()=>React.useContext(ServicesContext);

export { useServicesContext as default };
